import React from 'react';
export function Guarantee() {
  return <section className="w-full bg-stone-50 px-8 py-24 sm:px-14 sm:py-28" data-id="element-138" data-mp="1qalq4w8vplqd">
      <div className="mx-auto flex max-w-4xl flex-col items-center gap-10 text-center sm:flex-row sm:gap-14 sm:text-left" data-id="element-139" data-mp="1o2lq4y82a9za">
        <svg viewBox="0 0 200 200" className="h-40 w-40 shrink-0 -rotate-6 text-red-700 sm:h-44 sm:w-44" role="img" aria-label="Garantie satisfaction 7 jours" data-id="element-140" data-mp="222wjc7wug0nm">
          <defs data-id="element-141" data-mp="19e7lqiuzydgm">
            <path id="guarantee-stamp-path" d="M100,100 m-80,0 a80,80 0 1,1 160,0 a80,80 0 1,1 -160,0" data-id="element-142" data-mp="19fsh2ap4y0fj" />
          </defs>
          <circle cx="100" cy="100" r="95" fill="none" stroke="currentColor" strokeWidth="3" data-id="element-143" data-mp="14hhac8u5061j" />
          <circle cx="100" cy="100" r="64" fill="none" stroke="currentColor" strokeWidth="1.5" data-id="element-144" data-mp="1j65181t1frl5" />
          <text fill="currentColor" fontSize="14" fontWeight="700" letterSpacing="2" fontFamily="ui-sans-serif, system-ui, sans-serif" data-id="element-145" data-mp="1ec993fzggyxw">
            <textPath href="#guarantee-stamp-path" textLength="498" lengthAdjust="spacing" data-id="element-146" data-mp="lp6citecayaa">
              GARANTIE SATISFACTION · ACHETEZ EN TOUTE CONFIANCE ·
            </textPath>
          </text>
          <text x="100" y="112" textAnchor="middle" fill="currentColor" fontSize="64" fontFamily="ui-serif, Georgia, serif" data-id="element-147" data-mp="tymi48vjfoz8">
            7
          </text>
          <text x="100" y="136" textAnchor="middle" fill="currentColor" fontSize="13" fontWeight="700" letterSpacing="3" fontFamily="ui-sans-serif, system-ui, sans-serif" data-id="element-148" data-mp="yqmfpuo4y5sn">
            JOURS
          </text>
        </svg>

        <div data-id="element-149" data-mp="62qimounmbvc">
          <h2 className="font-serif text-4xl leading-tight tracking-tight text-slate-900 sm:text-5xl" data-id="element-150" data-mp="630ayj368v47">
            Garantie satisfaction 7 jours
          </h2>
          <p className="mt-5 max-w-xl text-lg leading-relaxed text-slate-900/75" data-id="element-151" data-mp="f0kexzsf55ii">
            Téléchargez le matériel et voyez comment il fonctionne dans vos séances. Si le pack ne
            correspond pas à vos attentes, contactez-nous par e-mail pour demander un remboursement dans
            les 7 jours suivant l'achat, selon nos conditions de garantie.
          </p>
          <p className="mt-4 max-w-xl text-sm leading-relaxed text-slate-900/60" data-id="element-152" data-mp="3rhyt6544h2h9">
            Cette garantie ne remplace pas vos droits prévus par le Code de la consommation.
          </p>
        </div>
      </div>
    </section>;
}